/* ═══════════════════════════════════════════════════════════════════════════
   MAISON D'VUE — Welcome popup (15% off for joining the letters)
   The markup and styles live in snippets/mdv-letters-popup.liquid, rendered
   once by the layout as a real Shopify customer form. This script only decides
   when it opens, validates, and remembers who has already seen or joined.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  // Named apart from the old necklace-draw popup's cookie (mdv_letters_seen),
  // so guests who dismissed that one still see this offer once.
  var COOKIE          = "mdv_welcome_seen"; // shared across every page
  var DISMISS_DAYS    = 7;                  // merely seen it -> ask again in a week
  var SUBSCRIBED_DAYS = 365;                // actually joined -> never nag again

  if (window.__mdvLettersLoaded) return;   // several templates load this script
  window.__mdvLettersLoaded = true;

  var overlay = document.getElementById("lettersOverlay");
  if (!overlay) return;                     // no popup on this page

  // Theme settings → Maison D'Vue welcome popup → "Delay", 1.7s by default.
  var delayMs = parseInt(overlay.getAttribute("data-delay-ms"), 10);
  if (isNaN(delayMs)) delayMs = 1700;

  var modal    = overlay.querySelector("#lettersModal");
  var form     = overlay.querySelector("#lettersForm");
  var submit   = overlay.querySelector("#lettersSubmit");
  var feedback = overlay.querySelector("#lettersFeedback");
  var emailEl  = overlay.querySelector("#lettersEmail");
  var hpEl     = overlay.querySelector("#lettersHp");
  var closeBtn = overlay.querySelector(".letters-close");
  var decline  = overlay.querySelector("#lettersDecline");

  function getCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    return parts.length === 2 ? parts.pop().split(";").shift() : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }

  function show(force) {
    var seen = getCookie(COOKIE);
    if (!force && seen) return;
    overlay.classList.add("visible");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("mdv-offer-open");
    // Never downgrade a subscriber's year-long mark to the one-week "shown".
    if (seen !== "subscribed") setCookie(COOKIE, "shown", DISMISS_DAYS);
  }
  function close() {
    overlay.classList.remove("visible");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("mdv-offer-open");
  }
  function setMsg(text, type) {
    feedback.textContent = text || "";
    feedback.classList.toggle("error", type === "error");
  }

  // Back from a successful signup: swap in the thank-you with the code.
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    setCookie(COOKIE, "subscribed", SUBSCRIBED_DAYS);
    modal.classList.add("submitted");
    show(true);
  }

  window.openLettersPopup = function (force) { show(force !== false); };

  document.addEventListener("click", function (e) {
    var target = e.target.closest('a[href="#letters"], a[href="#welcome"], .js-open-letters');
    if (target) {
      e.preventDefault();
      window.openLettersPopup(true);
    }
  });

  closeBtn.addEventListener("click", close);
  if (decline) decline.addEventListener("click", close);
  overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("visible")) close();
  });

  form.addEventListener("submit", function (e) {
    var email = (emailEl.value || "").trim();
    if (hpEl && hpEl.value) { e.preventDefault(); return; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      e.preventDefault(); setMsg("Please enter a valid email address.", "error"); return;
    }
    // Submit natively. Shopify binds invisible captcha to this form and refuses
    // anything posted around it, so the browser has to do the submitting.
    submit.disabled = true;
    setMsg("");
  });

  setTimeout(show, delayMs);
})();
